// put this in .env.development.local RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED=false
export const NODE_ENV = process.env.NODE_ENV
export const FRESHCHAT_TOKEN = process.env.NEXT_PUBLIC_FRESHCHAT_TOKEN
export const WEB_URL = process.env.NEXT_PUBLIC_WEB_URL
export const API_BASE = process.env.NEXT_PUBLIC_API_BASE_URL
export const API_BO = process.env.NEXT_PUBLIC_API_BO
export const PRODUCT_NAME = process.env.NEXT_PUBLIC_PRODUCT_NAME
export const SOCKET_ENDPOINT =
  process.env.NEXT_PUBLIC_SOCKET_ENDPOINT || 'https://api.pigspin.dev'
